import React, { ReactElement } from 'react'
import { FAQCard } from '@mindfulchefuk/components/FAQ/Card/FAQCard'
import { FAQProps } from '@mindfulchefuk/components/FAQ/FAQ.types'
import { Box, Stack, Text } from '@mindfulchefuk/design-system'
import { IllustrationContainer } from '@mindfulchefuk/design-system/layout/Container'

export const FAQ = ({
  questions,
  onCardClickTracking,
}: FAQProps): ReactElement => (
  <Box bg="salt" overflow="hidden">
    <IllustrationContainer
      illustrations="05"
      pt={48}
      pb={{ base: 144, md: 96 }}
    >
      <Box maxWidth={768} mx="auto">
        <Text as="h2" variant="heading-md" mb={40}>
          FAQs
        </Text>
        <Stack
          as="ul"
          listStyleType="none"
          z={1}
          position="relative"
          maxWidth={768}
          justify="center"
          mx="auto"
        >
          {questions.map(({ answer, question }) => (
            <li data-testid="FAQ-card" key={question}>
              <FAQCard
                question={question}
                answer={answer}
                onClickTracking={onCardClickTracking}
              />
            </li>
          ))}
        </Stack>
      </Box>
    </IllustrationContainer>
  </Box>
)
